<template>

<app-wrapper>

	<com-business v-if="isSessionBusiness" />
	<com-customer v-if="isSessionCustomer" />

</app-wrapper>

</template>

<script>

import comCustomer from './password/Customer'
import comBusiness from './password/Business'

export default {

    components: {
        'com-business': comBusiness,
        'com-customer': comCustomer
    }
    
}

</script>